export default __webpack_public_path__ + "static/media/infy.bfba88a7.svg";